import React from "react";

const AnswerEmojiIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      className={className}
    >
      <path
        d="M10.2216 19.0185C14.9263 19.0185 18.7402 15.2046 18.7402 10.5C18.7402 5.79532 14.9263 1.98145 10.2216 1.98145C5.517 1.98145 1.70312 5.79532 1.70312 10.5C1.70312 15.2046 5.517 19.0185 10.2216 19.0185Z"
        stroke="#828282"
        strokeWidth="1.7037"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.81445 12.2041C6.81445 12.2041 8.09223 13.9078 10.2219 13.9078C12.3515 13.9078 13.6293 12.2041 13.6293 12.2041"
        stroke="#828282"
        strokeWidth="1.7037"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66699 7.94434H7.67501"
        stroke="#828282"
        strokeWidth="1.7037"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7773 7.94434H12.7854"
        stroke="#828282"
        strokeWidth="1.7037"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AnswerEmojiIcon;
